import {
  ShipmentInput,
  ShipmentSummary,
  LineResult,
  FreightMode,
} from '@freight-cbm/shared-types';
import { computeCBM } from './cbm';
import { calcDIMWeight, calcChargeableWeight } from './dimWeight';
import { convertToKg } from './units';

export function calcShipmentSummary(shipment: ShipmentInput): ShipmentSummary {
  const lineResults: LineResult[] = [];
  let totalCBM = 0;
  let totalPackages = 0;
  let grossWeightKg = 0;
  let dimWeightKg = 0;

  for (const line of shipment.packages) {
    const cbm = computeCBM(line.length, line.width, line.height, line.dimUnit, line.quantity);
    const cbmPerPiece = line.quantity > 0 ? cbm / line.quantity : 0;
    const actualWeight = convertToKg(line.weight, line.weightUnit) * line.quantity;

    let lineDimWeight: number;
    if (shipment.mode === FreightMode.OceanLCL) {
      // Ocean LCL: volume equivalence (CBM × 1000 kg/CBM)
      lineDimWeight = cbm * 1000;
    } else {
      // Air / Courier: divisor-based DIM weight
      lineDimWeight = calcDIMWeight(
        line.length, line.width, line.height,
        line.dimUnit, line.quantity, shipment.dimDivisor,
      );
    }

    const result = calcChargeableWeight(actualWeight, isNaN(lineDimWeight) ? 0 : lineDimWeight);

    lineResults.push({
      packageId: line.id,
      cbm: isNaN(cbm) ? 0 : cbm,
      cbmPerPiece: isNaN(cbmPerPiece) ? 0 : cbmPerPiece,
      dimWeight: isNaN(lineDimWeight) ? 0 : lineDimWeight,
      actualWeight,
      chargeableWeight: result.chargeableWeightKg,
      weightBasis: result.weightBasis,
      quantity: line.quantity,
    });

    totalCBM += isNaN(cbm) ? 0 : cbm;
    totalPackages += line.quantity;
    grossWeightKg += actualWeight;
    dimWeightKg += isNaN(lineDimWeight) ? 0 : lineDimWeight;
  }

  const chargeResult = calcChargeableWeight(grossWeightKg, dimWeightKg);
  const cargoDensityKgPerCBM = totalCBM > 0 ? grossWeightKg / totalCBM : 0;

  return {
    totalCBM,
    totalPackages,
    grossWeightKg,
    dimWeightKg,
    chargeableWeightKg: chargeResult.chargeableWeightKg,
    weightBasis: chargeResult.weightBasis,
    lineResults,
    cargoDensityKgPerCBM,
  };
}
